export const LOADER_START = 'LOADER_START';
export const LOADER_STOP = 'LOADER_STOP';
export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
